import { Box, Card, List, ListItem, Typography } from "@mui/material";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";
import { useGetOne } from "react-admin";
// import { Link } from "react-router-dom";
import { Link } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import CustomSelect from "../unit/forms/CustomSelect";
import CircleProgress from "@mui/material/CircularProgress";

const hmLogo = () => {
  return <img src="/images/hm.png" style={{ height: "35px" }} width="35px" />;
};
interface RecordType {
  today_disbursed: number;
  today_ach_processed: number;
  today_ach_failed: number;
  newRegister: number;
  today_closed: number;
  today_paidOff: number;
  today_chargedOff: number;
  today_new?: number;
  approve?: number;
  decline?: number;
  paidoff?: number;
  chargedoff?: number;
}

const DailySummary = () => {
  const [record, setRecord] = React.useState<RecordType>({});
  const [datelimit, setDatelimit] = React.useState("Yesterday");
  const [load, setLoad] = React.useState(true);
  const { data, isLoading, error } = useGetOne("total/dashboard", { id: 1 });
  React.useEffect(() => {
    if (data) {
      setRecord(data);
      setLoad(false);
    }
  }, [data]);

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }
  // if (!record) {
  //   return <div>Loading...</div>;
  // }
  // console.log("record===>", record);
  let datelimitOptionAttrs: any = [];
  datelimitOptionAttrs.push({ label: "Select", value: "" });
  datelimitOptionAttrs.push({ label: "Yesterday", value: "Yesterday" });
  datelimitOptionAttrs.push({ label: "Month to Date", value: "Month to Date" });
  datelimitOptionAttrs.push({ label: "Last Month", value: "Last Month" });
  datelimitOptionAttrs.push({ label: "Year to Date", value: "Year to Date" });
  datelimitOptionAttrs.push({
    label: "Last Calendar Year",
    value: "Last Year",
  });

  const handleChangeDate = async (date: any) => {
    if (date == "") {
      return null;
    }
    const formJson = { datelimit: date };
    setLoad(true);
    const response = await sendRequest("total/dashboard", {
      id: 2,
      data: formJson,
    });
    if (response) {
      setRecord(response);
      setLoad(false);
    }
  };
  const curBank = localStorage.getItem("bank");
  return (
    <>
      <Card
        sx={{
          minHeight: 52,
          display: "flex",
          flexDirection: "column",
          flex: "1",
          "& a": {
            textDecoration: "none",
            color: "inherit",
          },
          borderRadius: "0px",
        }}
      >
        <Box
          sx={{
            position: "relative",
            overflow: "hidden",
            padding: "16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #e0e0e0",
            height: "75px",
            "& .icon": {
              color: "secondary.main",
            },
          }}
        >
          <Box className="icon">
            <Typography
              variant="body2"
              sx={{ fontWeight: "bold", fontSize: "16px", color: "grey" }}
            >
              Activity
            </Typography>
          </Box>
          <Box textAlign="right" sx={{ color: "grey" }}>
            {/* {formatDate("yesterday")} */}
            <CustomSelect
              id="dashboard-report-datelimit"
              name="datelimit"
              className="datelimit"
              sx={{ width: "190px", textAlign: "left" }}
              optionlist={datelimitOptionAttrs}
              value={datelimit}
              variant="outlined"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setDatelimit(e.target.value);
                handleChangeDate(e.target.value);
              }}
            />
          </Box>
          {/* */}
        </Box>

        <List
          dense={true}
          // id="list-daily-summary"
          sx={{
            width: "100%",
            // height: "calc(100vh - 200px)",
            height: "1070px",
            overflowY: "auto",
          }}
          id="dashboard-activity-list"
        >
          <ListItem>
            <ListItemSecondaryAction>
              <Box
                component="span"
                sx={{
                  marginRight: "1em",
                  color: "text.primary",
                }}
              ></Box>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem>
            <ListItemText
              primary={
                <Link
                  // to='/customers?filter={"status":"signUp2025_campaigns"}'
                  to='/customers?filter={"status":"signUp2026_direct"}'
                  sx={{
                    "&.RaLink-link": {
                      color: "#1976d2",
                    },
                    "&:hover": {
                      // color: "#1976d290",
                      textDecoration: "underline",
                    },
                  }}
                >
                  Customers Registered
                </Link>
              }
              secondary=""
            />
            <ListItemSecondaryAction>
              <Box
                component="span"
                sx={{
                  marginRight: "1em",
                  color: "text.primary",
                }}
                className="numericText"
              >
                {load ? "" : record?.newRegister}
              </Box>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem>
            <ListItemText
              primary={
                <Link
                  // to='/applications?filter={"status":"New"}'
                  to='/applications?filter={"status":"New","subStatus":"Verification Pending"}'
                  sx={{
                    "&.RaLink-link": {
                      color: "#1976d2",
                    },
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  Applications Submitted
                </Link>
              }
              secondary=""
            />
            <ListItemSecondaryAction>
              <Box
                component="span"
                sx={{
                  marginRight: "1em",
                  color: "text.primary",
                }}
                className="numericText"
              >
                {/* {record?.today_new} */}
                {load ? "" : record?.today_new}
              </Box>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem sx={{ mt: 2 }}>
            <ListItemText
              primary={
                <Link
                  // to='/applications?filter={"status":"Approved"}'
                  to='/applications?filter={"status":"Approved","subStatus":"Pending Signature"}'
                  sx={{
                    "&.RaLink-link": {
                      color: "#1976d2",
                    },
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  Applications Approved
                </Link>
              }
              secondary=""
            />
            <ListItemSecondaryAction>
              <Box
                component="span"
                sx={{
                  marginRight: "1em",
                  color: "text.primary",
                }}
                className="numericText"
              >
                {/* {record?.approve} */}
                {load ? "" : record?.approve}
              </Box>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem>
            <ListItemText
              primary={
                <Link
                  to='/applications?filter={"status":"Declined"}'
                  sx={{
                    "&": {
                      position: "relative",
                    },
                    "&.RaLink-link": {
                      color: "#1976d2",
                    },
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  Applications Declined
                </Link>
              }
              secondary=""
            />
            <ListItemSecondaryAction>
              <Box
                component="span"
                sx={{
                  marginRight: "1em",
                  color: "text.primary",
                }}
                className="numericText"
              >
                {/* {record?.decline} */}
                {load ? "" : record?.decline}
              </Box>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem sx={{ mt: 2 }}>
            <ListItemText
              primary={
                <Link
                  // to='/loans?filter={"status":"active","curStatus":"OK"}'
                  to='/applications?filter={"status":"Approved","subStatus":"Signature Completed"}'
                  sx={{
                    "&.RaLink-link": {
                      color: "#1976d2",
                    },
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  New Loans Closed
                </Link>
              }
              secondary=""
            />
            <ListItemSecondaryAction>
              <Box
                component="span"
                sx={{
                  marginRight: "1em",
                  color: "text.primary",
                }}
                className="numericText"
              >
                {/* {record?.today_closed} */}
                {load ? "" : record?.today_closed}
              </Box>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem>
            <ListItemText
              primary={
                <Link
                  // to='/loans?filter={"status":"active","curStatus":"OK"}'
                  to='/applications?filter={"status":"Approved","subStatus":"Signature Completed"}'
                  sx={{
                    "&.RaLink-link": {
                      color: "#1976d2",
                    },
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  New Loans Disbursed
                </Link>
              }
              secondary=""
            />
            <ListItemSecondaryAction>
              <Box
                component="span"
                sx={{
                  marginRight: "1em",
                  color: "text.primary",
                }}
                className="numericText"
              >
                {/* {record?.today_disbursed} */}
                {load ? "" : record?.today_disbursed}
              </Box>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem sx={{ mt: 2 }}>
            <ListItemText
              primary={
                <Link
                  // to='/achpayment?filter={"status":"Disbursement - Processed (30Days)"}'
                  to='/repayment?filter={"status":"repayment_past30processed"}'
                  sx={{
                    "&.RaLink-link": {
                      color: "#1976d2",
                    },
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  ACH Processed
                </Link>
              }
              secondary=""
            />
            <ListItemSecondaryAction>
              <Box
                component="span"
                sx={{
                  marginRight: "1em",
                  color: "text.primary",
                }}
                className="numericText"
              >
                {/* {record?.today_ach_processed} */}
                {curBank != "ircceo" && curBank != "nolb" ? (
                  <>N/A</>
                ) : (
                  <>{load ? "" : record?.today_ach_processed}</>
                )}
              </Box>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem>
            <ListItemText
              primary={
                <Link
                  // to='/achpayment?filter={"status":"Disbursement - Failed (30Days)"}'
                  to='/repayment?filter={"status":"repayment_past30initiatedButFailed"}'
                  sx={{
                    "&.RaLink-link": {
                      color: "#1976d2",
                    },
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  ACH Failed
                </Link>
              }
              secondary=""
            />
            <ListItemSecondaryAction>
              <Box
                component="span"
                sx={{
                  marginRight: "1em",
                  color: "text.primary",
                }}
                className="numericText"
              >
                {/* {record?.today_ach_failed} */}
                {curBank != "ircceo" && curBank != "nolb" ? (
                  <>N/A</>
                ) : (
                  <>{load ? "" : record?.today_ach_failed}</>
                )}
              </Box>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem sx={{ mt: 2 }}>
            <ListItemText
              primary={
                <Link
                  to='/loans?filter={"status":"Paid-Off"}'
                  sx={{
                    "&.RaLink-link": {
                      color: "#1976d2",
                    },
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  Loans Paid Off
                </Link>
              }
              secondary=""
            />
            <ListItemSecondaryAction>
              <Box
                component="span"
                sx={{
                  marginRight: "1em",
                  color: "text.primary",
                }}
                className="numericText"
              >
                {/* {record?.today_paidOff} */}
                {curBank != "ircceo" && curBank != "nolb" ? (
                  <>N/A</>
                ) : (
                  <>{load ? "" : record?.today_paidOff}</>
                )}
              </Box>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem>
            <ListItemText
              primary={
                <Link
                  to='/loans?filter={"status":"Charged-Off"}'
                  sx={{
                    "&.RaLink-link": {
                      color: "#1976d2",
                    },
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  Loans Charged Off
                </Link>
              }
              secondary=""
            />
            <ListItemSecondaryAction>
              <Box
                component="span"
                sx={{
                  marginRight: "1em",
                  color: "text.primary",
                }}
                className="numericText"
              >
                {/* {record?.today_chargedOff} */}
                {curBank != "ircceo" && curBank != "nolb" ? (
                  <>N/A</>
                ) : (
                  <>{load ? "" : record?.today_chargedOff}</>
                )}
              </Box>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </Card>

      {/* <CardWithLogo to="/#" icon={hmLogo} title="Happy Mango" subtitle="">
        ddd
      </CardWithLogo> */}
    </>
  );
};

export default DailySummary;
